<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card-title class="px-0">{{ cardTitle }}</v-card-title>
      </v-col>
    </v-row>
    <v-row v-if="!readonly" justify="end">
      <v-col cols="12" sm="6" lg="4" xl="3">
        <v-btn block outlined color="primary" @click="showAddExpenseModal">
          ADD EXPENSE
          <v-icon right>add</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <ExpensesTable
          :expensesList="expensesList"
          :readonly="readonly"
          :showDeleteButton="true"
          :showEditButton="true"
          :showActive="showActive"
          @showDeleteExpenseConfirmationDialogHandler="showDeleteExpenseConfirmationDialogHandler"
          @showEditExpenseModal="showEditExpenseModalHandler"
        ></ExpensesTable>
      </v-col>
    </v-row>
    <ExpenseAddModal
      ref="expenseAddModal"
      :showActive="showActive"
      :showExpenseAmountType="showExpenseAmountType"
      @addExpense="addExpenseHandler"
    ></ExpenseAddModal>
    <ExpenseEditModal
      ref="expenseEditModal"
      :showActive="showActive"
      :showExpenseAmountType="showExpenseAmountType"
      @expenseChange="editExpenseHandler"
    ></ExpenseEditModal>
    <ConfirmationModal
      :contentText="'Are you sure you want to delete the selected expense?'"
      :showModal="showDeleteExpenseConfirmationDialog"
      :title="'Delete Confirmation'"
      :toolbarColor="'primary'"
      @cancel-click="closeDeleteExpenseConfirmationDialogHandler"
      @ok-click="deleteExpenseHandler"
    ></ConfirmationModal>
  </div>
</template>

<script>
import ExpensesTable from '@/components/expenses/ExpensesTable'
import ExpenseAddModal from '@/components/expenses/ExpenseAddModal'
import ExpenseEditModal from '@/components/expenses/ExpenseEditModal'
import { ConfirmationModal } from '@/components/dialogs'

export default {
  components: {
    ExpenseEditModal,
    ExpenseAddModal,
    ExpensesTable,
    ConfirmationModal
  },
  props: [
    'cardTitle',
    'expensesList',
    'readonly',
    'showActive',
    'showExpenseAmountType'
  ],
  data () {
    return {
      expensesInternalList: this.expensesList,
      expenseId: 100000,
      showDeleteExpenseConfirmationDialog: null,
      expenseIdToDelete: null
    }
  },
  watch: {
    expensesInternalList () {
      this.$emit('expensesListChange', this.expensesInternalList)
    },
    expensesList () {
      this.expensesInternalList = this.expensesList
    }
  },
  methods: {
    showAddExpenseModal () {
      this.$refs.expenseAddModal.showModal()
    },
    addExpenseHandler (newExpense) {
      this.expensesInternalList.push({ id: ++this.expenseId, ...newExpense })
    },
    showEditExpenseModalHandler (item) {
      this.$refs.expenseEditModal.setExpenseToEdit(item)
      this.$refs.expenseEditModal.showModal()
    },
    editExpenseHandler (expenseUpdated) {
      let index = this.expensesInternalList.findIndex(item => item.id === expenseUpdated.id)
      this.expensesInternalList.splice(index, 1, expenseUpdated)
    },
    showDeleteExpenseConfirmationDialogHandler (ExpenseId) {
      this.expenseIdToDelete = ExpenseId
      this.showDeleteExpenseConfirmationDialog = true
    },
    closeDeleteExpenseConfirmationDialogHandler () {
      this.expenseIdToDelete = null
      this.showDeleteExpenseConfirmationDialog = false
    },
    deleteExpenseHandler () {
      let indexToDelete = this.expensesInternalList.findIndex(item => item.id === this.expenseIdToDelete)
      this.expensesInternalList.splice(indexToDelete, 1)
      this.closeDeleteExpenseConfirmationDialogHandler()
    }
  }
}
</script>
